import { Record as record } from 'immutable';

import { construct, resolve } from '../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../helpers/Records';

const timeString = (hhmm) => /^\d\d:\d\d$/.test(hhmm) ? hhmm : null;

const fieldSchema = {
    startTime: [ resolve.with(timeString) ],
    endTime: [ resolve.with(timeString) ]
};

export default class Timeslot extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(Timeslot, json, getResolvers(fieldSchema));
    }

    toString () {
        return `${this.startTime}-${this.endTime}`;
    }
}



// WEBPACK FOOTER //
// ./src/records/Timeslot.js